import { useQuery } from '@apollo/client';
import { navigate } from 'gatsby';
import React, { FC, useEffect, useState } from 'react';

import DashboardTask from '@ui/molecules/DashboardTask';

import { doesNotExist } from '@utils/general';

import GET_CONTACTS from '@graphql/queries/getEmergencyContacts.query.gql';

import { EMERGENCY_CONTACT } from '../Tasks.data';

const EmergencyContactTask: FC<ITaskProps> = ({
	updateTaskStatus,
	heading,
	description,
	image,
	alt,
	loading,
}) => {
	const [done, setDone] = useState<boolean>(false);

	const {
		data,
		loading: dataLoading,
		error,
	} = useQuery(GET_CONTACTS, {
		fetchPolicy: 'no-cache',
	});

	useEffect(() => {
		if (doesNotExist(data)) return;

		const contacts = data?.emergencyContacts?.nodes;

		setDone(!doesNotExist(contacts));
		updateTaskStatus(EMERGENCY_CONTACT, false, !doesNotExist(contacts));
	}, [dataLoading]);

	const onClick = () => {
		if (!done) navigate('/app/member/account/contacts');
	};

	return (
		<DashboardTask
			heading={heading}
			description={description}
			image={image}
			alt={alt}
			done={done}
			onClick={onClick}
			loading={loading}
		/>
	);
};

export default EmergencyContactTask;
